var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSanta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "75px",
    height: "105px",
    viewBox: "0 0 75 105",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "santa",
    transform: "translate(0.000000, -0.000000)",
    fill: "#9EBD84",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "43.1239255 93.8477794 43.1239255 104.136103 37.5 104.136103 31.8760745 104.136103 31.8760745 93.8477794 0.079512894 93.8477794 17.3112464 63.1149713 8.56697708 63.1149713 24.7489255 34.5666189 15.7682665 34.5666189 37.5 0.104226361 59.2317335 34.5666189 50.2510745 34.5666189 66.4330229 63.1149713 57.6887536 63.1149713 74.9204871 93.8477794"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanta);
export default __webpack_public_path__ + "static/media/santa.ba5128394e76947113f9269530b9aa7d.svg";
export { ForwardRef as ReactComponent };